import { render } from "./PhieuCongMy.vue?vue&type=template&id=e5b0dec8&scoped=true"
import script from "./PhieuCongMy.vue?vue&type=script&lang=js"
export * from "./PhieuCongMy.vue?vue&type=script&lang=js"

import "./PhieuCongMy.vue?vue&type=style&index=0&id=e5b0dec8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5b0dec8"]])

export default __exports__